/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartVennIntersect = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        d="M15 5a7 7 0 0 1 0 14 1 1 0 0 1 0-2 5 5 0 0 0 0-10 1 1 0 0 1 0-2zM9 5a1 1 0 1 1 0 2 5 5 0 0 0 0 10 1 1 0 0 1 0 2A7 7 0 0 1 9 5z"
        fill="currentcolor"
      />
      <path
        d="M12 7.263C10.752 8.378 10 10.13 10 12s.752 3.622 2 4.738c1.248-1.116 2-2.87 2-4.738s-.752-3.622-2-4.737"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgChartVennIntersect as ChartVennIntersect };
